module.exports = __webpack_public_path__ + "img/dep_gamestoysandsports@3x.7caafc83.png";